import { IconPack } from '@fortawesome/fontawesome-common-types';
import { faDiagramNested, faMoonStars, faSunBright } from '@fortawesome/pro-regular-svg-icons';

export const proRegularSvgIconsPack: IconPack = {
  faSunBright,
  faMoonStars,
  faDiagramNested,
};
